<template>
    <div style="width: 100%; height: 28px">
        <v-container
            v-if="page && show"
            id="breadcrumb-container"
            class="caption"
        >
            <v-row column justify-center align-center no-gutters>
                <v-col cols="12">
                    <nuxt-link
                        :to="localePath('index')"
                        color="primary"
                        class="breadcrumb--home"
                        ><TranslatableStringComponent :tstring="{string: 'home'}" /></nuxt-link
                    >
                    <span
                        v-if="
                            breadcrumbs &&
                            breadcrumbs.parent.label[$i18n.locale]
                        "
                        class="breadcrumb_sep"
                        ><fa :icon="['fal', 'chevron-right']" class="fa-sm"
                    /></span>
                    <nuxt-link
                        :class="
                            breadcrumbs.parent.route.en === '/resources/'
                                ? 'disable-link'
                                : ''
                        "
                        v-if="
                            breadcrumbs &&
                            breadcrumbs.parent.label[$i18n.locale]
                        "
                        style="text-transform: capitalize"
                        :to="breadcrumbs.parent.route[$i18n.locale]"
                    >
                        {{ breadcrumbs.parent.label[$i18n.locale] }}
                    </nuxt-link>
                    <span class="breadcrumb_sep"
                        ><fa :icon="['fal', 'chevron-right']" class="fa-sm"
                    /></span>
                    <span class="breadcrumb_last" aria-current="page">{{
                        page.title ? page.title[$i18n.locale] : 'Page Not Found'
                    }}</span>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import breadcrumbRoute from '~/util/breadcrumbRoute'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'Breadcrumbs',
    props: {
        show: {
            type: Boolean,
            default: true,
        },
        page: {
            type: Object,
            default: null,
        },
    },
    components: {
        TranslatableStringComponent,
    },
    data() {
        return {
            previousRoute: null,
        }
    },
    computed: {
        breadcrumbs() {
            return breadcrumbRoute({
                page: this.page,
                previousRouteObj: this.previousRouteObj,
            })
        },
        previousRouteObj() {
            const obj = {
                label: this.label,
                route: this.route,
            }
            return obj
        },
        label() {
            if (this.previousRoute && this.previousRoute.params) {
                if (this.previousRoute.params.pn2) {
                    return `${this.previousRoute.params.slug} (${this.previousRoute.params.pn}/${this.previousRoute.params.pn1}/${this.previousRoute.params.pn2})`
                } else if (this.previousRoute.params.pn1) {
                    return `${this.previousRoute.params.slug} (${this.previousRoute.params.pn}/${this.previousRoute.params.pn1})`
                } else if (this.previousRoute.params.pn) {
                    return `${this.previousRoute.params.slug} (${this.previousRoute.params.pn})`
                } else {
                    return `${this.previousRoute.params.slug}`
                }
            } else {
                return null
            }
        },
        route() {
            if (this.previousRoute) {
                return this.previousRoute.path
            } else {
                return null
            }
        },
    },
    mounted() {
        // if this is a stringy object do object stuff, otherwise return null
        this.previousRoute =
            localStorage &&
            localStorage.getItem('c3prev') &&
            localStorage.getItem('c3prev').includes('{')
                ? JSON.parse(localStorage.getItem('c3prev'))
                : null
    },
}
</script>
<style lang="scss" scoped>
.disable-link {
    pointer-events: none;
}
</style>
